'use client'

import { cn } from '@brew/ui/cn'
import type { ReactNode } from 'react'

export function PromptBoxDock({
  children,
  variant = 'absolute',
}: {
  children: ReactNode
  variant?: 'absolute' | 'fixed' | 'sticky'
}) {
  if (variant === 'sticky') {
    return (
      <div className="sticky bottom-4 z-50 px-4 pb-4">
        <div className="mx-auto max-w-2xl rounded-lg bg-background/95 shadow-[0_-10px_40px_rgba(0,0,0,0.18)] backdrop-blur-xl dark:border dark:border-border dark:bg-background">
          {children}
        </div>
      </div>
    )
  }

  return (
    <div
      className={cn('right-0 bottom-0 left-0 z-20 p-4', {
        absolute: variant === 'absolute',
        fixed: variant === 'fixed',
      })}
    >
      <div className="mx-auto max-w-2xl rounded-lg bg-background/95 shadow-[0_-10px_40px_rgba(0,0,0,0.18)] backdrop-blur-xl dark:border dark:border-border dark:bg-background">
        {children}
      </div>
    </div>
  )
}
